import { Formik, FieldArray, Field } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { BsFillPlusSquareFill } from "react-icons/bs";
import CustomEditor5 from "../../../../utils/ckEditor5";
import { AiFillMinusSquare } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { required, positiveNumber } from "../../../../utils/validations";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import {
  clearCountryOverview,
  getCountryPopularPlacesColleges,
} from "../../../../../store/slices/country";
import SaveAndSaveNext from "../../../utils/saveAndSaveNext";
import Loading from "../../../utils/loader";

const OverviewForm = (props) => {
  const dispatch = useDispatch();
  const [stateBasedColleges, setStateBasedColleges] = useState({});
  const firstErrorRef = useRef(null);
  const { id } = useParams();
  const [statusError, setStatusError] = useState(null);
  const {
    countryPopularPlacesCollegesData,
    countryPopularPlacesCollegesLoading,
    putCountryOverviewError,
    message,
    putCountryOverviewLoading,
  } = useSelector((state) => state.cmsCountry);
  const [collegeSearch, setCollegeSearch] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [debouncedSearchTerm] = useDebounce(collegeSearch, 1000);
  const onSearch = (value, stateId) => {
    if (value !== collegeSearch) setCollegeSearch(value);
    setStateId(stateId);
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      dispatch(
        getCountryPopularPlacesColleges({
          country_id: id,
          state: stateId,
          college_term: collegeSearch,
        })
      );
    }
  }, [debouncedSearchTerm, stateId]);
  useEffect(() => {
    if (countryPopularPlacesCollegesData) {
      let abc = { ...stateBasedColleges };
      abc[`state_${countryPopularPlacesCollegesData?.state?.id}`] =
        countryPopularPlacesCollegesData?.colleges;
      setStateBasedColleges(abc);
    }
  }, [countryPopularPlacesCollegesData]);

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(clearCountryOverview());
      }, 5000);
    }
  }, [message]);

  const canPublishCountryData = props.userPermissions.some(
    (permission) =>
      permission.codename === "Can Publish Country Data-countrydata"
  );

  // Check if the user has the "Can Unpublish Country Data" permission
  const canUnpublishCountryData = props.userPermissions.some(
    (permission) =>
      permission.codename === "Can Unpublish Country Data-countrydata"
  );
  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert severity={putCountryOverviewError ? `error` : `success`}>
            {message}
          </Alert>
        )}
      </div>

      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!values?.country_name) {
            errors.country_name = required(values?.country_name);
          }
          if (!values?.currency) {
            errors.currency = required(values?.currency);
          }
          if (!values?.primary_language) {
            errors.primary_language = required(values?.primary_language);
          }
          if (
            !/^[1-9]+[0-9]*$/.test(values.local_student) &&
            values.local_student
          ) {
            errors.local_student = "Invalid Integer";
          }
          if (
            !/^[1-9]+[0-9]*$/.test(values.international_student) &&
            values.international_student
          ) {
            errors.international_student = "Invalid Integer";
          }
          if (
            !/^[1-9]+[0-9]*$/.test(values.indian_student) &&
            values.indian_student
          ) {
            errors.indian_student = "Invalid Integer";
          }
          if (values.remark.trim().split(/\s+/).length > 500) {
            errors.remark = `Word limit Exceeded please enter only 500 words
            ${500 - values.remark.trim().split(/\s+/).length}`;
          }
          values.popular_places_data.forEach((element, index) => {
            if (values.popular_places_data[index]?.state) {
              if (!values.popular_places_data[index]?.colleges?.length > 0) {
                errors[`popular_places_data.${index}.colleges`] =
                  "Please remove state or select college";
              }
            }
            if (
              values.popular_places_data[index]?.state &&
              values.popular_places_data[index]?.colleges
            ) {
              if (!values.popular_places_data[index]?.weight) {
                errors[`popular_places_data.${index}.weight`] = required(
                  values.popular_places_data[index]?.weight
                );
              }
            }
            if (values.popular_places_data[index]?.weight) {
              errors[`popular_places_data.${index}.weight`] = positiveNumber(
                values.popular_places_data[index]?.weight
              );
              // Check for unique weight
              const currentWeight = values.popular_places_data[index]?.weight;
              const isWeightUnique = values.popular_places_data.every(
                (obj, i) => index === i || obj.weight != currentWeight
              );
              if (!isWeightUnique) {
                errors[`popular_places_data.${index}.weight`] =
                  "Weight should be unique";
              }
            }
            Object.keys(errors).forEach((key) => {
              if (!errors[key]) {
                delete errors[key];
              }
            });
          });
          return errors;
        }}
        onSubmit={(values) => {
          setStatusError(null);
          props.submit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          setTouched,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h5>General Information</h5>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="country_name">
                      <Form.Label>Country Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="country_name"
                        className={"input_pd"}
                        value={values?.country_name}
                        onChange={handleChange}
                        readOnly
                      />
                      {errors?.country_name && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.country_name}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="currency">
                      <Form.Label>Currency*</Form.Label>
                      <Form.Control
                        type="text"
                        name="currency"
                        className={"input_pd"}
                        value={values?.currency}
                        onChange={handleChange}
                        readOnly
                      />
                      {errors?.currency && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.currency}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="primary_language">
                      <Form.Label>Primary Language*</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="primary_language"
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option}
                        value={values?.primary_language}
                        isClearable={true}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "primary_language",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        onBlur={handleBlur}
                        options={props.languageOptions}
                      />
                      {errors?.primary_language &&
                        touched?.primary_language && (
                          <div ref={firstErrorRef} className="error">
                            {errors?.primary_language}
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="other_language">
                      <Form.Label>Other Language</Form.Label>
                      <Select
                        isMulti
                        className="basic-single"
                        classNamePrefix="select"
                        name="other_language"
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        value={values?.other_language}
                        isClearable={true}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "other_language",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                        }}
                        options={props.languageOptions}
                      />
                      {errors?.other_language && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.other_language}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>

            <div className={"general_information"}>
              <div className={"examfilter"}>
                <h5>Total Students</h5>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="local_student">
                      <Form.Label>Local</Form.Label>
                      <Form.Control
                        type="text"
                        name="local_student"
                        className={"input_pd"}
                        value={values?.local_student}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors?.local_student && touched.local_student && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.local_student}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="international_student"
                    >
                      <Form.Label>International</Form.Label>
                      <Form.Control
                        type="text"
                        name="international_student"
                        className={"input_pd"}
                        value={values?.international_student}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors?.international_student &&
                        touched.international_student && (
                          <div ref={firstErrorRef} className="error">
                            {errors?.international_student}
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="indian_student">
                      <Form.Label>Indian</Form.Label>
                      <Form.Control
                        type="text"
                        name="indian_student"
                        className={"input_pd"}
                        value={values?.indian_student}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors?.indian_student && touched.indian_student && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.indian_student}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
            {values.popular_places_data?.length > 0 && (
              <div className={"basic_details_country"}>
                <div className={"examfilter"}>
                  <h4 className={"examfilter_heading"}>Popular Places</h4>
                  <FieldArray name="popular_places_data">
                    {({ insert, remove, push }) => (
                      <div>
                        {values.popular_places_data?.map((element, index) => (
                          <>
                            <Row>
                              <Col md={4}>
                                <Form.Group className="mb-3" controlId="state">
                                  <Form.Label>State</Form.Label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    name={`popular_places_data.${index}.state`}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={
                                      values.popular_places_data[index].state
                                    }
                                    onChange={(value) => {
                                      setFieldValue(
                                        `popular_places_data.${index}.state`,
                                        value
                                      );
                                      setFieldValue(
                                        `popular_places_data.${index}.colleges`,
                                        null
                                      );
                                      setFieldValue(
                                        `popular_places_data.${index}.weight`,
                                        ""
                                      );
                                    }}
                                    options={
                                      props.stateOptions
                                        ? props.stateOptions?.filter(
                                            (obj) =>
                                              !values?.popular_places_data
                                                ?.map(
                                                  (innerObj) =>
                                                    innerObj?.state?.id
                                                )
                                                ?.includes(parseInt(obj.id))
                                          )
                                        : []
                                    }
                                    isClearable={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="college"
                                >
                                  <Form.Label>Colleges</Form.Label>
                                  <Select
                                    isMulti
                                    className="basic-single"
                                    filterOption={false}
                                    classNamePrefix="select"
                                    name={`popular_places_data.${index}.colleges`}
                                    getOptionLabel={(option) =>
                                      option.college_name
                                    }
                                    getOptionValue={(option) =>
                                      option.college_id
                                    }
                                    value={
                                      values.popular_places_data?.[index]
                                        ?.colleges
                                    }
                                    components={{
                                      NoOptionsMessage: () => {
                                        return (
                                          <>
                                            {countryPopularPlacesCollegesLoading ? (
                                              <Loading />
                                            ) : (
                                              <div className="text-center opacity-50">
                                                {values?.popular_places_data[
                                                  index
                                                ]?.state?.id
                                                  ? "No Options"
                                                  : "Please Select State To Get Colleges"}
                                              </div>
                                            )}
                                          </>
                                        );
                                      },
                                    }}
                                    onInputChange={(value) => {
                                      if (
                                        values?.popular_places_data[index]
                                          ?.state?.id &&
                                        value
                                      ) {
                                        onSearch(
                                          value,
                                          values?.popular_places_data[index]
                                            ?.state?.id
                                        );
                                      }
                                    }}
                                    onFocus={() => {
                                      if (
                                        values?.popular_places_data[index]
                                          ?.state?.id
                                      ) {
                                        dispatch(
                                          getCountryPopularPlacesColleges({
                                            country_id: id,
                                            state:
                                              values?.popular_places_data[index]
                                                ?.state?.id,
                                          })
                                        );
                                      }
                                    }}
                                    onChange={(value) =>
                                      setFieldValue(
                                        `popular_places_data.${index}.colleges`,
                                        value
                                      )
                                    }
                                    options={
                                      stateBasedColleges[
                                        `state_${values.popular_places_data[index]?.state?.id}`
                                      ]
                                    }
                                    isClearable={true}
                                  />
                                </Form.Group>
                                {errors[
                                  `popular_places_data.${index}.colleges`
                                ] &&
                                  touched[`popular_places_data`]?.[index]?.[
                                    `colleges`
                                  ] && (
                                    <div ref={firstErrorRef} className="error">
                                      {
                                        errors[
                                          `popular_places_data.${index}.colleges`
                                        ]
                                      }
                                    </div>
                                  )}
                              </Col>
                              <Col>
                                <Form.Group className="mb-3" controlId="weight">
                                  <Form.Label>Weight*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`popular_places_data.${index}.weight`}
                                    className={"input_pd"}
                                    value={
                                      values?.popular_places_data[index]?.weight
                                    }
                                    onChange={(e) => {
                                      setFieldValue(
                                        `popular_places_data.${index}.weight`,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    disabled={
                                      !values.popular_places_data[index]
                                        ?.state ||
                                      !values.popular_places_data[index]
                                        ?.colleges
                                    }
                                  />
                                </Form.Group>
                                {errors[
                                  `popular_places_data.${index}.weight`
                                ] &&
                                  touched[`popular_places_data`]?.[index]?.[
                                    `weight`
                                  ] && (
                                    <div ref={firstErrorRef} className="error">
                                      {
                                        errors[
                                          `popular_places_data.${index}.weight`
                                        ]
                                      }
                                    </div>
                                  )}
                              </Col>
                              <Col className="bottom_right_button_container">
                                <div className={"imageField_fieldArray"}>
                                  <div className={"imageField_add"}>
                                    {values.popular_places_data?.length > 1 && (
                                      <span
                                        className={"imageField_minus_icon"}
                                        onClick={() => {
                                          remove(index);
                                        }}
                                      >
                                        <AiFillMinusSquare />
                                      </span>
                                    )}
                                    {index ==
                                      values.popular_places_data?.length -
                                        1 && (
                                      <span
                                        className={"imageField_add_icon"}
                                        onClick={() =>
                                          push({
                                            state: null,
                                            colleges: null,
                                            weight: "",
                                          })
                                        }
                                      >
                                        <BsFillPlusSquareFill />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>
            )}
            <div>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="remark">
                  <Form.Label>Internal Term remark</Form.Label>
                    <CustomEditor5
                      initData={values.remark}
                      onChange={(data) => {
                        setFieldValue("remark", data);
                      }}
                    />
                </Form.Group>
              </Col>
            </div>
            {errors?.remark && (
              <div ref={firstErrorRef} className="error">
                {errors?.remark}
              </div>
            )}
            <div className={"domain"}>
              <div className={"examfilter"}>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="status">
                      <div className={"checkBox_select"}>
                        <Field
                          type="checkbox"
                          name="status"
                          className={"mode_checkbox"}
                          component={Form.Check}
                          checked={values.status}
                          onChange={(e) => {
                            if (values.status) {
                              if (canUnpublishCountryData) {
                                setFieldValue("status", !values.status);
                              } else {
                                setStatusError(
                                  "You Can not Unpublished this please take permission"
                                );
                              }
                            } else {
                              if (canPublishCountryData) {
                                setFieldValue("status", !values.status);
                              } else {
                                setStatusError(
                                  "You Can not published this please take permission"
                                );
                              }
                            }
                          }}
                        />
                        <b> Publishing Status</b>
                      </div>
                      {statusError && (
                        <div className="text-danger">{statusError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {values.last_updated && (
                    <span>Last Updated date: {values.last_updated}</span>
                  )}
                </Row>
                <Row>
                  {values.updated_by && (
                    <span>Updated by: {values.updated_by} </span>
                  )}
                </Row>
              </div>
            </div>

            <Row>
              <Col className="mt-3">
                <SaveAndSaveNext
                  firstErrorRef={firstErrorRef}
                  setTouched={setTouched}
                  errors={errors}
                  setSaveAndNext={props.setSaveAndNext}
                  loading={putCountryOverviewLoading}
                />
              </Col>
            </Row>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default OverviewForm;
